import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './index.scss';
import $ from 'jquery';

class Navbar extends Component {
  handleToggleHamburger = () => {
    this.props.onToggleHamburger()
  }

  render() {
    return (
      <div className={`navbar`}>
        <Link to="/" className="logo -normal" onClick={() => $.fn.fullpage.moveTo('game')}>
          <img src={`/content-img/comingout_logotype.png`} alt="logo"/>
        </Link>

        {/* <Link to="/" className="logo -small" onClick={() => $.fn.fullpage.moveTo('game')}>
          <img src={`/content-img/logo-comingout-small.svg`} alt="logo"/>
        </Link> */}

        <div className={`icons -right ${this.props.location.pathname === '/posts' ? '-hidden' : ''}` }>
          <div className="icon -support">
            <a href="https://www.zeczec.com/projects/simpleinfo?r=03c3b70380" target="_blank"><img className="support" src="/content-img/icon-navbar-support.svg" alt="" /></a>
          </div>
          <div className="icon">
            <img className="toggle" src="/content-img/icon-navbar-toggle.svg" alt="" onClick={this.handleToggleHamburger}/>
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/components/Navbar/pure.js